import React from 'react'
import styled from 'styled-components'

import LottieScrollAnimation from '@/components/lottie-scroll-animation'
import RichText, {hasRichText} from '@/components/rich-text'
import {Text} from '@/components/text'
import type {AnimationBlockFragment, AnimationBlockSecondaryFragment} from '@/graphql-types'
import {Layout, Section} from '@/styles/grid'
import {tokens} from '@/theme'
import mq from '@/utils/media-query'

type Props = {
    slice: AnimationBlockFragment | AnimationBlockSecondaryFragment
}

export const AnimationBlockSlice = React.forwardRef<HTMLDivElement, Props>(({slice}, ref) => {
    return (
        <StyledSection>
            <Layout $variant="two-asymmetrical" $mirrored={true} ref={ref}>
                {slice.primary.title && hasRichText(slice.primary.body.richText) && (
                    <StickyContainer>
                        <Text as="h2" $variant="heading-base">
                            {slice.primary.title}
                        </Text>

                        <Body>
                            <RichText $color="muted" content={slice.primary.body.richText} />
                        </Body>
                    </StickyContainer>
                )}

                <LottieScrollAnimation
                    animationUrl={slice.primary.lottie_json_file.url}
                    endFrame={slice.primary.animation_frames}
                    placeholderImage={slice.primary.placeholder}
                />
            </Layout>
        </StyledSection>
    )
})

const MOBILE_BP = 'sm'
const TABLET_BP = 'md'
const LAPTOP_BP = 'lg'

const StyledSection = styled(Section)`
    ${mq.min(TABLET_BP)} {
        min-height: 700px;
    }

    ${mq.min(LAPTOP_BP)} {
        min-height: 900px;
    }
`

export const Body = styled.div`
    margin-top: ${tokens.spacing20};

    ${mq.min(MOBILE_BP)} {
        margin-top: ${tokens.spacing28};
    }
`

const StickyContainer = styled.div`
    ${mq.min(MOBILE_BP)} {
        position: sticky;
        top: 32%;
    }
`
